import { fetchToken } from '~/assistant/api/fetches';
import { CLASSNAME } from '~/assistant/utils/constants';
import { setCookie, getCookie } from '~/assistant/utils/cookies';
import { bem } from '~/common/classname';
import './styles.scss';

type Props = {
  [key: string]: any;
};

class Iframe {
  props: Props;

  constructor(props: Props) {
    this.props = { ...props };
    this.render();

    window.addEventListener('message', this.handleMessage);
  }

  handleMessage(event: MessageEvent<any>) {
    const {
      buzzni_shopping_gpt_token_error: token_error,
      buzzni_shopping_gpt_close_content: close_content,
    } = event.data;

    if (close_content) {
      const container: HTMLElement = document.querySelector(
        `.${bem([CLASSNAME, 'iframe'])}`
      );
      container.style.visibility = 'hidden';
      return;
    }

    if (!!token_error) {
      this.fetchToken();
      return;
    }
  }

  // 토큰 발급
  fetchToken() {
    const token = getCookie('bai_access_token');
    const iframe: HTMLIFrameElement = document.querySelector(
      `.${bem([CLASSNAME, 'iframe', 'container'])}`
    );

    if (!!token) {
      setTimeout(() => {
        iframe.contentWindow.postMessage(
          { access_token: token, headerTitle: this.props.headerTitle },
          '*'
        );
      }, 1000);
    } else {
      const { shop: clientId, dKey: deviceId } = this.props;
      fetchToken(deviceId, clientId).then((res) => {
        const {
          access_token,
          access_token_exp,
          refresh_token,
          refresh_token_exp,
        } = res;

        setCookie('bai_access_token', access_token, access_token_exp);
        setCookie('bai_refresh_token', refresh_token, refresh_token_exp);
        iframe.contentWindow.postMessage(
          { access_token, headerTitle: this.props.headerTitle },
          '*'
        );
      });
    }
  }

  render() {
    const classPrefix = bem([CLASSNAME, 'iframe']);
    const { productId, shop, mode } = this.props;

    const domain =
      mode === 'local'
        ? `http://localhost:3002`
        : `https://oksoon-sdk${mode === 'release' ? '' : '-stage'}.buzzni.com`;

    const iframeSrc = `${domain}/product/${productId}?${new URLSearchParams({
      ...(!!shop && { shop }),
    })}`;

    // 전체 container element 생성
    const container = document.createElement('div');
    container.className = `${classPrefix}`;
    document.body.append(container);

    // dimmed element 생성
    const dimmed = document.createElement('div');
    dimmed.className = `${bem([classPrefix, 'dimmed'])}`;
    dimmed.onclick = () => {
      container.style.visibility = 'hidden';
    };
    container.append(dimmed);

    // iframe element 생성
    const iframe = document.createElement('iframe');
    iframe.className = `${bem([classPrefix, 'container'])}`;
    iframe.src = iframeSrc;
    iframe.onload = () => this.fetchToken();
    container.append(iframe);
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--buzzni-ai-vh', `${vh}px`);
  }
}

export default Iframe;
